module.exports = __webpack_public_path__ + "img/magnifying_glass.04d1ab84.svg";